import { FormControl, InputLabel, Select } from "@mui/material";
import MultiSelectCalendar from "../../../components/universal/MultiSelectCalendar";

import { addDays } from "date-fns";
import { useDateFormatting } from "shared-ui/contexts/Locale/useDateFormatting";

interface MenuStartDatesMultiSelectProps {
  dates: string[];
  onChange: (dates: string[]) => void;
  className?: string;
}

const MenuStartDatesMultiSelect = ({ onChange, dates, className }: MenuStartDatesMultiSelectProps) => {
  const { formatDateWithLocale } = useDateFormatting();

  const value =
    dates.length === 0 ? "No dates selected" : dates.length === 1 ? formatDateWithLocale(dates[0]) : `${dates.length} dates selected`;

  return (
    <FormControl variant="outlined" className={className}>
      <InputLabel id="menu-dates-select-label">Dates</InputLabel>
      <Select
        sx={{ height: "36px", mt: 2 }}
        labelId="menu-dates-select-label"
        id="menu-dates-select"
        label="Dates"
        value={value}
        renderValue={v => <>{v}</>}
        error={!dates.length}
        aria-label="Select menu dates">
        <MultiSelectCalendar
          dates={dates}
          onChange={onChange}
          minDate={addDays(new Date(), -1)} />
      </Select>
    </FormControl>
  );
};

export default MenuStartDatesMultiSelect;
